import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Product } from 'src/app/model/product.model';

// Needed to work inside Django
declare const CSRF_TOKEN: string;

@Injectable({
    providedIn: 'root',
})
export class ProductService {

    TYPE_SHADING = 'shading';
    TYPE_GLAZING = 'glazing';

    // The main app component will update this
    // if the server sends in an 'initialTab' value as a prop.
    public initialTab = 'glazing';

    public selectedItem: Product | null = null;

    // http options used for making API calls
    private httpOptions: {
        headers: HttpHeaders
    };

    // list of products

    private baseURL = environment.baseURL;
    private productListAPIUrl = this.baseURL + '/api/v2/products/';
    private productUrl = this.baseURL + '/products/';

    constructor(private http: HttpClient) {
        if (environment.production) {
            this.httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-CSRFToken': CSRF_TOKEN
                })
            };
        } else {
            this.httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Authorization: `TOKEN ${environment.apiToken}`
                })
            };
        }
    }

    public setInitialTab(initialTabName: string) {
        if (initialTabName !== 'shading' && initialTabName !== 'glazing') {
            initialTabName = 'glazing';
        }
        this.initialTab = initialTabName;
    }

    getProductList(productType: string): Observable<Product[]> {
        const listURL = `${this.productListAPIUrl}?type=${productType}`;
        return this.http.get<Product[]>(listURL, this.httpOptions)
            .pipe(
                map(data => data.map(item => new Product(item))),
                catchError(this.handleError('getProductList', []))
            );
    }


    getProduct(id: number): Observable<Product> {
        const productUrl = `${this.productListAPIUrl}${id}`;
        return this.http.get<Product>(productUrl, this.httpOptions)
            .pipe(
                tap(_ => console.log(`fetched product ${id}`)),
                catchError(this.handleError<Product>(`get Product id=${id}`))
            );
    }


    openNewTabWithProduct(product: Product, format: string = '') {
        let url = '';
        if (format === 'json') {
            url = `${this.productListAPIUrl}${product.token}/?format=json`;
        } else if (format === 'csv') {
            url = `${this.productUrl}${product.token}/?format=csv`;
        } else {
            url = `${this.productUrl}${product.token}/`
        }
        // open new tab in user's browser
        window.open(url, '_blank');
    }

    openNewTabWithProductDataFile(product: Product) {
        const downloadURL = `${this.productUrl}${product.token}/datafile`;
        // open new tab in user's browser
        window.open(downloadURL, '_blank');
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
